import { Sprout, Compass, UserRound } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import { Stagger, StaggerItem } from "@/components/Reveal";

const PUBLICOS = [
  {
    icon: UserRound,
    title: "Adultos",
    text: "Psicoterapia voltada à compreensão das demandas emocionais, comportamentais e relacionais, respeitando a história e singularidade de cada pessoa.",
    testId: "publico-adultos",
  },
  {
    icon: Compass,
    title: "Adolescentes",
    text: "Espaço de escuta e acompanhamento para questões emocionais, comportamentais, sociais, acadêmicas e relacionadas ao desenvolvimento.",
    testId: "publico-adolescentes",
  },
  {
    icon: Sprout,
    title: "Crianças",
    text: "Acompanhamento psicológico considerando desenvolvimento, emoções, comportamento, relações familiares e os diferentes contextos nos quais a criança está inserida.",
    testId: "publico-criancas",
  },
];

const Publicos = () => (
  <section data-testid="publicos-section" className="py-20 lg:py-28">
    <div className="container-x">
      <SectionHeading eyebrow="04 — Públicos" title="Cuidado em diferentes momentos da vida." testId="publicos" />
      <Stagger className="mt-14 grid gap-6 md:grid-cols-3" gap={0.12}>
        {PUBLICOS.map((p) => (
          <StaggerItem key={p.title}>
            <article
              data-testid={p.testId}
              className="group flex h-full flex-col rounded-3xl border border-raiz-900/10 bg-cream p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-raiz-600/50 hover:bg-raiz-50 lg:p-10"
            >
              <p.icon
                aria-hidden="true"
                className="h-8 w-8 text-raiz-600 transition-transform duration-500 group-hover:-translate-y-1 group-hover:translate-x-1"
              />
              <h3 className="mt-8 font-serif text-2xl font-light text-ink lg:text-3xl">{p.title}</h3>
              <p className="mt-4 text-sm leading-relaxed text-ink/65">{p.text}</p>
            </article>
          </StaggerItem>
        ))}
      </Stagger>
    </div>
  </section>
);

export default Publicos;
